import { useQuery } from '@apollo/client'
import { customerOrderDetail } from 'services/customerData'
import { VisitureOrderHistory } from 'lib/core/data/customer/orders/types'

export interface Order {
  id: number
  created_at?: string
  grand_total?: any
  increment_id?: any
  order_items?: any[]
  status?: string
  visiture_order_history: VisitureOrderHistory
}

export const useOrderDetail = (orderId: number) => {
  const { loading: loadingOrderDetail, data } = useQuery(customerOrderDetail, {
    variables: { orderId },
    fetchPolicy: 'no-cache'
  })

  const orderDetail = data?.customerOrderDetail
  const shippingInfo = orderDetail?.shipping_address
  const shippingName = `${shippingInfo?.firstname} ${shippingInfo?.lastname}`
  const shippingAddress = `${shippingInfo?.street} ${shippingInfo?.city}, ${shippingInfo?.region} ${shippingInfo?.postcode}`

  return {
    orderDetail,
    loadingOrderDetail,
    shippingName,
    shippingAddress
  }
}
